import { webserver,get } from "./request.js";

export const getDetail = (param={}) => {
  return new Promise((resolve, reject) => {
    webserver(
      "/1.0/h5_works_qry",
      param,
      true
    )
      .then(resp => {
        console.log(resp);
        resolve(resp);
      })
      .catch(e => {
        reject(e);
      });
  });
};

export const report = reportInfo => {
  return new Promise((resolve, reject) => {
    webserver(
      "1.0/user_works_feed",
      {
        works_id: reportInfo.works_id,
        works_type: 8,
        feed_type: reportInfo.feed_type,
        remark: reportInfo.remark
      },
      true
    )
      .then(resp => {
        console.log(resp);
        resolve(resp);
      })
      .catch(e => {
        reject(e);
      });
  });
};


export const pvuv = (params) => {
  get("http://proxyweb.peiyinge.com/h5stat/stat.gif", {
    ...params
  });
  // get("http://172.31.4.34/stat.gif", {
  //   ...params
  // });
  
};
